import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useVModel } from '@vueuse/core';
import { mdiChevronDown, mdiMenuOpen } from '@mdi/js';
import { mdiUnfoldLessHorizontal, mdiUnfoldMoreHorizontal } from '@mdi/js';
import ChevronUpDown from './ChevronUpDown.vue';

interface IProps {
  value?: IFilters[];
  showFilter: boolean;
}

interface IEmits {
  (event: 'update:modelValue', value: IFilters[] | undefined): void;
  (event: 'change', value: IFilters[] | undefined): void;
  (event: 'close'): void;
  (event: 'limpar'): void;
  (event: 'filtrar'): void;
}

interface IFilters {
  expandido: boolean;
  campo: string;
  label: string;
  valoresSubFiltroResponseDTO: IValoresSubFiltro[];
}

interface IValoresSubFiltro {
  checked: boolean;
  descricao: string;
  quantidade: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpansionPanel',
  props: {
    value: null,
    showFilter: { type: Boolean }
  },
  emits: ["update:modelValue", "change", "close", "limpar", "filtrar"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update:modelValue', value: IFilters[] | undefined): void;
  (event: 'change', value: IFilters[] | undefined): void;
  (event: 'close'): void;
  (event: 'limpar'): void;
  (event: 'filtrar'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: IFilters[];
  showFilter: boolean;
};




const btnExpand = ref(true);

const expandirTodos = () => {
  btnExpand.value = !btnExpand.value;
  filtroInterno.value?.forEach((element) => {
    element.expandido = !btnExpand.value;
  });
};

const filtroInterno = useVModel(props, 'value', emit);

return { __sfc: true,props, emit, btnExpand, expandirTodos, filtroInterno, mdiChevronDown, mdiMenuOpen, mdiUnfoldLessHorizontal, mdiUnfoldMoreHorizontal, ChevronUpDown }
}

})